export const dropNonSignificantZeros = (
  num: number | string | undefined,
  fixedLength?: number
): number | string | void => {
  if (num === undefined) return num;
  if (!!fixedLength) num = Number(num).toFixed(fixedLength);
  return Number(num);
};
